// External deps

import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Button } from 'ypf-pas-general-ui-components';
import { useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';

// Internal deps
import { stepEnum, stepEnumOfAccordion } from '../Constants';
import './ButtonCreate.scss';
import { eventPendingAssignmentId } from '../../../utils/dataStatus';

const ButtonsCreate = ({
  setShowModalExit,
  setShowModalDelete,
  createServiceRequest,
  saveDraft,
  isReplyRequest
}) => {
  const { values, errors } = useFormikContext();
  const { id } = useParams();
  const accordionFields = Object.keys(stepEnumOfAccordion);
  const hasErrorInCurrentStep =
    errors?.accordions?.length &&
    errors?.accordions?.some((accordionErrors, accordionIndex) => {
      if (!accordionErrors) {
        return false;
      }

      const step = values?.accordions[accordionIndex]?.accordionStep;
      const currentStepKey = accordionFields[step - 1];

      return !!accordionErrors[currentStepKey];
    });

  const disableSave =
    errors?.accordions?.some((accordion) => accordion?.service) ||
    values?.currentStep !== stepEnum.services ||
    hasErrorInCurrentStep;

  const showSendButton =
    values?.accordions?.length &&
    values?.accordions.every(
      (accordion) => accordion?.accordionStep >= stepEnumOfAccordion.associatedUsers
    );

  const enabledButtonDraft =
    values?.accordions?.length &&
    values?.accordions?.every(
      (accordion) => accordion?.service?.needDate && accordion?.service?.probDate
    );

  const hasErrorInForm = () => {
    let errorsToAnalyze = {};
    // We need to allow imputationObject error when we pick this event
    // eslint-disable-next-line no-unused-vars
    const { imputationObject, ...restOfErrors } = errors;

    if (
      values?.ubication?.event?.id === eventPendingAssignmentId ||
      values?.imputationObject?.wells[0]?.event?.id === eventPendingAssignmentId
    ) {
      errorsToAnalyze = restOfErrors;
    } else {
      errorsToAnalyze = errors;
    }

    return !!Object.keys(errorsToAnalyze).length || values?.ubication?.ubication === null;
  };

  const showDeleteButton = values?.currentStep >= stepEnum.services && id;

  const renderTooltipCreate = (propsTooltip) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Tooltip id="button-tooltip" {...propsTooltip}>
      Agregar Solicitud de Servicio
    </Tooltip>
  );

  const renderTooltipSave = (propsTooltip) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Tooltip id="button-tooltip" {...propsTooltip}>
      Guardar en Estado Borrador
    </Tooltip>
  );

  return (
    <div className="d-flex justify-content-center gap">
      <Button
        label="Salir"
        onClick={() => setShowModalExit(true)}
        type="button"
        variant="outline-primary"
      />
      <OverlayTrigger
        delay={{
          show: 250,
          hide: 400
        }}
        overlay={renderTooltipSave}
        placement="top"
      >
        <div>
          <Button
            disabled={!isReplyRequest ? disableSave : !enabledButtonDraft}
            label="Guardar"
            onClick={saveDraft}
            type="submit"
            variant="outline-primary"
          />
        </div>
      </OverlayTrigger>
      {showDeleteButton && (
        <Button
          label="Eliminar"
          onClick={() => setShowModalDelete(true)}
          type="button"
          variant="outline-danger"
        />
      )}
      {showSendButton && (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={renderTooltipCreate}
          placement="top"
        >
          <div>
            <Button
              disabled={hasErrorInForm()}
              label="Enviar solicitud"
              onClick={createServiceRequest}
              type="submit"
              variant="primary"
            />
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default ButtonsCreate;

ButtonsCreate.propTypes = {
  setShowModalExit: PropTypes.func.isRequired,
  setShowModalDelete: PropTypes.func.isRequired,
  createServiceRequest: PropTypes.func.isRequired,
  saveDraft: PropTypes.func.isRequired,
  isReplyRequest: PropTypes.bool
};
ButtonsCreate.defaultProps = {
  isReplyRequest: false
};
